(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /*
      Movimiento Premium (Casa Duno):
      - Capa principal: la pista se desliza un producto (600 ms, curva firma 0.4, 0, 0.2, 1).
      - Capa secundaria: la foto que entra se asienta con una escala mínima (1.035 → 1), 60 ms después.
      - Capa ambiental: línea fina que marca el tiempo hasta el próximo avance.
      Se anima con Web Animations API para que el carrusel conserve su movimiento
      aunque el tema acorte las transiciones CSS en "reducir movimiento".
    */
    const DURATION = 600;
    const EASE = 'cubic-bezier(0.4, 0, 0.2, 1)';
    const EASE_SETTLE = 'cubic-bezier(0.2, 0, 0, 1)';
    const FADE_OUT = { duration: 220, easing: 'cubic-bezier(0.4, 0, 1, 1)' };
    const FADE_IN = { duration: 320, easing: 'cubic-bezier(0, 0, 0.2, 1)' };
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const canAnimate = typeof Element.prototype.animate === 'function';
    const instances = new Map();

    class FeaturedCarousel {
      constructor(section) {
        this.section = section;
        this.root = section.querySelector('[data-carousel]');
        this.viewport = this.root.querySelector('[data-carousel-viewport]');
        this.track = this.root.querySelector('[data-carousel-track]');
        this.status = this.root.querySelector('[data-carousel-status]');
        this.controls = section.querySelector('[data-carousel-controls]');
        this.prevButton = section.querySelector('[data-carousel-prev]');
        this.nextButton = section.querySelector('[data-carousel-next]');
        this.toggleButton = section.querySelector('[data-carousel-toggle]');
        this.progress = section.querySelector('[data-carousel-progress]');
        this.progressBar = this.progress?.querySelector('.carousel-progress__bar');
        this.autoplay = this.root.dataset.autoplay === 'true';
        this.interval = Math.max(2000, parseFloat(this.root.dataset.interval) || 4500);
        this.reducedMode = this.root.dataset.reducedMotion || 'slide';

        this.x = 0;
        this.busy = false;
        this.drag = null;
        this.hovering = false;
        this.focused = false;
        this.userPaused = false;
        this.editorPaused = false;
        this.inView = false;
        this.timer = null;
        this.deadline = 0;
        this.remaining = this.interval;
        this.cycleTotal = this.interval;
        this.progressAnim = null;
        this.suppressClick = false;

        this.abort = new AbortController();
        const opts = { signal: this.abort.signal };

        this.root.classList.add('is-ready');

        this.prevButton?.addEventListener('click', () => this.go(-1, true), opts);
        this.nextButton?.addEventListener('click', () => this.go(1, true), opts);
        this.toggleButton?.addEventListener('click', () => this.setUserPaused(!this.userPaused), opts);

        // Pausa con el mouse encima (carrusel y controles)
        [this.root, this.controls].forEach((el) => {
          if (!el) return;
          el.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') { this.hovering = true; this.resume(); } }, opts);
          el.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') { this.hovering = false; this.resume(); } }, opts);
        });

        // Pausa mientras el foco del teclado esté dentro del carrusel o sus controles
        section.addEventListener('focusin', () => { this.focused = true; this.resume(); }, opts);
        section.addEventListener('focusout', (e) => {
          if (e.relatedTarget && section.contains(e.relatedTarget)) return;
          this.focused = false;
          this.resume();
        }, opts);

        // Arrastre con mouse y deslizamiento táctil
        this.viewport.addEventListener('pointerdown', (e) => this.onPointerDown(e), opts);
        this.viewport.addEventListener('pointermove', (e) => this.onPointerMove(e), opts);
        this.viewport.addEventListener('pointerup', (e) => this.onPointerUp(e), opts);
        this.viewport.addEventListener('pointercancel', (e) => this.onPointerUp(e, true), opts);
        this.viewport.addEventListener('dragstart', (e) => e.preventDefault(), opts);
        this.viewport.addEventListener('click', (e) => {
          if (!this.suppressClick) return;
          e.preventDefault();
          e.stopPropagation();
          this.suppressClick = false;
        }, { capture: true, signal: this.abort.signal });

        document.addEventListener('visibilitychange', () => this.resume(), opts);
        reducedMotion.addEventListener('change', () => this.update(), opts);

        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.viewport);

        if ('IntersectionObserver' in window) {
          this.viewObserver = new IntersectionObserver(([entry]) => {
            this.inView = entry.isIntersecting;
            this.resume();
          }, { threshold: 0.35 });
          this.viewObserver.observe(this.root);

          // Precarga las fotos de todos los productos antes de que el carrusel quede a la vista
          this.preloadObserver = new IntersectionObserver(([entry], obs) => {
            if (!entry.isIntersecting) return;
            this.track.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
            obs.disconnect();
          }, { rootMargin: '400px 0px' });
          this.preloadObserver.observe(this.root);
        } else {
          this.inView = true;
        }

        this.update();
        this.startCycle();
      }

      get visible() {
        return parseInt(getComputedStyle(this.root).getPropertyValue('--visible'), 10) || 1;
      }

      get step() {
        const first = this.track.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return first ? first.getBoundingClientRect().width + gap : 0;
      }

      // 'slide' | 'fade' | 'instant' según la preferencia del visitante y la opción del editor
      get motion() {
        if (!canAnimate) return 'instant';
        if (!reducedMotion.matches) return 'slide';
        return this.reducedMode === 'pause' ? 'instant' : this.reducedMode;
      }

      get autoplayEnabled() {
        if (!this.autoplay || this.isStatic) return false;
        return !(reducedMotion.matches && this.reducedMode === 'pause');
      }

      update() {
        this.isStatic = this.track.children.length <= this.visible;
        this.root.classList.toggle('is-static', this.isStatic);
        if (this.controls) this.controls.hidden = this.isStatic;
        if (this.toggleButton) this.toggleButton.hidden = !this.autoplayEnabled;
        if (this.progress) this.progress.hidden = !this.autoplayEnabled;
        if (!this.busy) this.setTransform(0);
        this.updateInert();
        this.resume();
      }

      // Solo los productos visibles reciben foco; los demás quedan inertes hasta entrar en pantalla
      updateInert() {
        const visible = this.visible;
        Array.from(this.track.children).forEach((slide, i) => {
          slide.inert = !this.isStatic && i >= visible;
        });
      }

      setTransform(x) {
        this.x = x;
        this.track.style.transform = x ? `translate3d(${x}px, 0, 0)` : '';
      }

      // Capa principal
      async slideTo(x, easing = EASE, duration = DURATION) {
        const from = this.x;
        this.setTransform(x);
        if (this.motion === 'instant' || from === x) return;
        const anim = this.track.animate(
          [{ transform: `translate3d(${from}px, 0, 0)` }, { transform: `translate3d(${x}px, 0, 0)` }],
          { duration, easing }
        );
        await anim.finished.catch(() => {});
      }

      // Capa secundaria: la foto que entra se asienta apenas, con un leve retraso
      settle(slide) {
        if (!slide || this.motion !== 'slide' || reducedMotion.matches) return;
        slide.querySelectorAll('.card__image--primary').forEach((img) => {
          img.animate([{ transform: 'scale(1.035)' }, { transform: 'scale(1)' }], {
            duration: 900,
            delay: 60,
            easing: EASE_SETTLE,
            fill: 'backwards',
          });
        });
      }

      // Alternativa para "reducir movimiento": fundido sin desplazamiento lateral
      async crossfade(reorder) {
        const out = this.track.animate([{ opacity: 1 }, { opacity: 0 }], { ...FADE_OUT, fill: 'forwards' });
        await out.finished.catch(() => {});
        reorder();
        const fadeIn = this.track.animate([{ opacity: 0 }, { opacity: 1 }], FADE_IN);
        out.cancel();
        await fadeIn.finished.catch(() => {});
      }

      async go(direction, manual = false) {
        if (this.busy || this.isStatic || this.drag) {
          if (!manual) this.startCycle();
          return;
        }
        this.busy = true;
        this.pauseTimer();
        const forward = () => this.track.append(this.track.firstElementChild);
        const backward = () => this.track.prepend(this.track.lastElementChild);

        if (this.motion === 'fade') {
          await this.crossfade(direction > 0 ? forward : backward);
        } else if (direction > 0) {
          const step = this.step;
          this.settle(this.track.children[this.visible]);
          await this.slideTo(-step);
          forward();
          this.setTransform(0);
        } else {
          const step = this.step;
          backward();
          this.setTransform(-step);
          this.settle(this.track.firstElementChild);
          await this.slideTo(0);
        }
        this.finishMove(manual);
      }

      finishMove(manual) {
        this.updateInert();
        this.busy = false;
        if (manual) this.announce();
        // Tras una interacción manual, el autoplay espera el doble antes de continuar
        this.startCycle(manual ? this.interval * 2 : this.interval);
      }

      announce() {
        const first = this.track.firstElementChild;
        if (!this.status || !first) return;
        const title = first.querySelector('.card__title')?.textContent.trim() || '';
        this.status.textContent = `${first.getAttribute('aria-label')}: ${title}`;
      }

      onPointerDown(e) {
        if (this.isStatic || this.busy || (e.pointerType === 'mouse' && e.button !== 0)) return;
        this.drag = { id: e.pointerId, x0: e.clientX, y0: e.clientY, dx: 0, active: false, step: this.step };
        this.pauseTimer();
      }

      onPointerMove(e) {
        const d = this.drag;
        if (!d || e.pointerId !== d.id) return;
        const dx = e.clientX - d.x0;
        const dy = e.clientY - d.y0;
        if (!d.active) {
          if (Math.abs(dx) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) {
            this.drag = null;
            this.resume();
            return;
          }
          d.active = true;
          this.busy = true;
          this.root.classList.add('is-dragging');
          try { this.viewport.setPointerCapture(e.pointerId); } catch (err) { /* sin captura */ }
          // Un producto a la izquierda para poder arrastrar hacia atrás
          this.track.prepend(this.track.lastElementChild);
          d.base = -d.step;
        }
        d.dx = Math.max(-d.step, Math.min(d.step, dx));
        this.setTransform(d.base + d.dx);
      }

      async onPointerUp(e, cancelled = false) {
        const d = this.drag;
        if (!d || e.pointerId !== d.id) return;
        this.drag = null;
        if (!d.active) {
          this.resume();
          return;
        }
        this.root.classList.remove('is-dragging');
        this.suppressClick = true;
        setTimeout(() => { this.suppressClick = false; }, 350);

        const threshold = Math.min(d.step * 0.18, 60);
        let shift = 0;
        if (!cancelled && d.dx < -threshold) shift = 1;
        if (!cancelled && d.dx > threshold) shift = -1;

        // Al soltar: desaceleración que sigue la inercia del gesto
        await this.slideTo(d.base - shift * d.step, EASE_SETTLE, 450);
        for (let i = 0; i < 1 + shift; i++) this.track.append(this.track.firstElementChild);
        this.setTransform(0);
        this.finishMove(shift !== 0);
      }

      setUserPaused(paused) {
        this.userPaused = paused;
        if (this.toggleButton) {
          this.toggleButton.dataset.state = paused ? 'paused' : 'playing';
          this.toggleButton.setAttribute('aria-label', paused ? this.toggleButton.dataset.labelPlay : this.toggleButton.dataset.labelPause);
        }
        this.resume();
      }

      get shouldRun() {
        return (
          this.autoplayEnabled &&
          !this.userPaused &&
          !this.hovering &&
          !this.focused &&
          !this.editorPaused &&
          !this.drag &&
          !this.busy &&
          this.inView &&
          !document.hidden
        );
      }

      // Nuevo ciclo completo (después de cada avance)
      startCycle(total = this.interval) {
        this.pauseTimer();
        this.cycleTotal = total;
        this.remaining = total;
        this.progressAnim?.cancel();
        this.progressAnim = null;
        if (this.progressBar && canAnimate) {
          this.progressAnim = this.progressBar.animate(
            [
              { transform: 'scaleX(0)', opacity: 0, offset: 0 },
              { opacity: 1, offset: Math.min(0.08, 300 / total) },
              { transform: 'scaleX(1)', opacity: 1, offset: 1 },
            ],
            { duration: total, easing: 'linear', fill: 'both' }
          );
          this.progressAnim.pause();
        }
        this.resume();
      }

      // Reanuda desde donde quedó (el tiempo restante se conserva durante las pausas)
      resume() {
        this.controls?.classList.toggle('is-paused', this.userPaused);
        if (!this.shouldRun) {
          this.pauseTimer();
          return;
        }
        if (this.timer) return;
        if (this.remaining < 250) this.remaining = 250;
        this.deadline = performance.now() + this.remaining;
        this.timer = setTimeout(() => {
          this.timer = null;
          this.remaining = 0;
          this.go(1);
        }, this.remaining);
        if (this.progressAnim) {
          this.progressAnim.currentTime = this.cycleTotal - this.remaining;
          this.progressAnim.play();
        }
      }

      pauseTimer() {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
          this.remaining = Math.max(0, this.deadline - performance.now());
        }
        this.progressAnim?.pause();
      }

      destroy() {
        this.pauseTimer();
        this.progressAnim?.cancel();
        this.abort.abort();
        this.resizeObserver?.disconnect();
        this.viewObserver?.disconnect();
        this.preloadObserver?.disconnect();
        this.track.getAnimations?.().forEach((a) => a.cancel());
        this.track.style.transform = '';
        this.root.classList.remove('is-ready', 'is-static', 'is-dragging');
      }
    }

    const init = (scope = document) => {
      scope.querySelectorAll('[data-carousel-section]').forEach((section) => {
        if (instances.has(section) || !section.querySelector('[data-carousel]')) return;
        instances.set(section, new FeaturedCarousel(section));
      });
      if (scope.matches?.('[data-carousel-section]') && !instances.has(scope)) {
        instances.set(scope, new FeaturedCarousel(scope));
      }
    };

    const destroyWithin = (scope) => {
      instances.forEach((instance, section) => {
        if (scope === section || scope.contains(section)) {
          instance.destroy();
          instances.delete(section);
        }
      });
    };

    const instancesWithin = (scope) => Array.from(instances.entries()).filter(([section]) => scope.contains(section)).map(([, inst]) => inst);

    init();
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    document.addEventListener('shopify:section:unload', (e) => destroyWithin(e.target));
    document.addEventListener('shopify:section:select', (e) => instancesWithin(e.target).forEach((c) => { c.editorPaused = true; c.resume(); }));
    document.addEventListener('shopify:section:deselect', (e) => instancesWithin(e.target).forEach((c) => { c.editorPaused = false; c.resume(); }));
  })();
  (() => {
    /*
      Escenario con scroll: el recorrido de la página dentro de la sección define la posición.
      - Cada producto tiene una "meseta" (queda quieto un tramo) y la transición entre productos
        usa una curva ease-in-out, así el scroll se siente guiado y no mecánico.
      - Capa principal: producto central (escala, posición). Secundaria: laterales desenfocados.
        Ambiental: fondo que cambia de tono y texto gigante con contramovimiento.
    */
    const PALETTE = ['#E8E4DC', '#E4DCD0', '#ECE8E1', '#DEE0DA', '#E7DBD1', '#DDD7CC'];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const stages = new Map();

    const clamp = (v, min, max) => Math.min(max, Math.max(min, v));
    const easeInOut = (u) => (u < 0.5 ? 4 * u * u * u : 1 - Math.pow(-2 * u + 2, 3) / 2);
    // Meseta corta (8 % en cada extremo): el producto se asienta un instante y el cambio ocupa casi todo el recorrido
    const hold = (t) => easeInOut(clamp((t - 0.08) / 0.84, 0, 1));
    const hexToRgb = (hex) => [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
    const mix = (a, b, t) => {
      const ca = hexToRgb(a);
      const cb = hexToRgb(b);
      return `rgb(${ca.map((v, i) => Math.round(v + (cb[i] - v) * t)).join(', ')})`;
    };

    class FeaturedStage {
      constructor(section) {
        this.section = section;
        this.stage = section.querySelector('[data-stage]');
        this.sticky = section.querySelector('[data-stage-sticky]');
        this.cards = Array.from(section.querySelectorAll('[data-stage-card]'));
        this.infos = Array.from(section.querySelectorAll('[data-stage-info]'));
        this.links = Array.from(section.querySelectorAll('[data-stage-link]'));
        this.ghost = section.querySelector('[data-stage-ghost]');
        this.current = section.querySelector('[data-stage-current]');
        this.status = section.querySelector('[data-stage-status]');
        this.prevButton = section.querySelector('[data-stage-prev]');
        this.nextButton = section.querySelector('[data-stage-next]');
        this.reducedMode = section.dataset.reducedMotion || 'slide';
        this.count = this.cards.length;
        this.f = 0;
        this.target = 0;
        this.active = -1;
        this.raf = null;
        this.last = 0;
        this.announceNext = false;

        this.abort = new AbortController();
        const opts = { signal: this.abort.signal };

        this.stage.classList.add('is-ready');

        window.addEventListener('scroll', () => this.onScroll(), { passive: true, signal: this.abort.signal });
        window.addEventListener('resize', () => this.measure(), opts);
        reducedMotion.addEventListener('change', () => this.render(), opts);

        this.prevButton?.addEventListener('click', () => this.goTo(this.active - 1), opts);
        this.nextButton?.addEventListener('click', () => this.goTo(this.active + 1), opts);

        // Un producto lateral lleva al centro; el central abre la página del producto
        this.cards.forEach((card, i) => {
          card.addEventListener('click', (e) => {
            if (i === this.active) return;
            e.preventDefault();
            this.goTo(i);
          }, opts);
        });

        this.sticky.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(this.active + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.goTo(this.active - 1); }
        }, opts);

        // Precarga las fotos cuando la sección se acerca
        if ('IntersectionObserver' in window) {
          this.preload = new IntersectionObserver(([entry], obs) => {
            if (!entry.isIntersecting) return;
            this.section.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
            obs.disconnect();
          }, { rootMargin: '800px 0px' });
          this.preload.observe(this.stage);
        }

        this.measure();
        this.f = this.target;
        this.render();
      }

      // Con "reducir movimiento" y la opción en fundido/pausa: solo fundido, sin escala ni desplazamiento
      get calm() {
        return reducedMotion.matches && this.reducedMode !== 'slide';
      }

      measure() {
        this.width = this.sticky.clientWidth;
        this.mobile = window.innerWidth < 750;
        this.onScroll();
      }

      computeTarget() {
        const rect = this.stage.getBoundingClientRect();
        const range = Math.max(1, rect.height - this.sticky.offsetHeight);
        return clamp(-rect.top / range, 0, 1) * (this.count - 1);
      }

      onScroll() {
        this.target = this.computeTarget();
        if (!this.raf) {
          this.last = performance.now();
          this.raf = requestAnimationFrame((t) => this.tick(t));
        }
      }

      // Suavizado: la escena sigue al scroll con una leve inercia
      tick(time) {
        this.raf = null;
        // El primer cuadro puede traer una marca de tiempo anterior: nunca usar un intervalo negativo
        const dt = clamp(time - this.last, 0, 64);
        this.last = time;
        // Inercia corta: la escena sigue al dedo o la rueda casi sin demora
        const k = 1 - Math.exp(-dt / 65);
        this.f = clamp(this.f + (this.target - this.f) * k, 0, Math.max(0, this.count - 1));
        if (Math.abs(this.target - this.f) < 0.0005) this.f = this.target;
        this.render();
        if (this.f !== this.target) this.raf = requestAnimationFrame((t) => this.tick(t));
      }

      render() {
        const n = this.count;
        const base = clamp(Math.floor(this.f), 0, Math.max(0, n - 1));
        const e = n > 1 ? hold(this.f - base) : 0;
        const pos = Math.min(n - 1, base + e);
        const calm = this.calm;
        const spread = (this.mobile ? 0.34 : 0.255) * this.width;
        const side = this.mobile ? 0.42 : 0.5;
        const back = this.mobile ? 0.3 : 0.36;
        const lift = this.mobile ? 0.03 : 0.05;

        this.cards.forEach((card, i) => {
          const d = i - pos;
          const a = Math.abs(d);
          let x = 0;
          let y = 0;
          let sc = 1;
          let o = Math.max(0, 1 - a * 1.6);
          let b = 0;
          if (!calm) {
            sc = a <= 1 ? 1 - a * (1 - side) : side - Math.min(1, a - 1) * (side - back);
            x = Math.sign(d) * (a <= 1 ? a * spread : spread + Math.min(1.5, a - 1) * spread * 0.42);
            y = -Math.min(1, a) * lift * this.sticky.offsetHeight;
            o = a <= 1 ? 1 - a * 0.15 : Math.max(0, 0.85 - (a - 1) * 0.85);
            // Desenfoque en pasos de 0,5 px: menos repintado por cuadro, movimiento más fluido
            b = Math.round(Math.min(3, a * 1.8) * 2) / 2;
          }
          card.style.transform = `translate3d(calc(-50% + ${x.toFixed(1)}px), ${y.toFixed(1)}px, 0) scale(${sc.toFixed(4)})`;
          card.style.opacity = o.toFixed(3);
          card.style.filter = b > 0.05 ? `blur(${b.toFixed(2)}px)` : '';
          card.style.zIndex = String(100 - Math.round(a * 10));
          card.style.visibility = o <= 0.01 ? 'hidden' : '';
        });

        // Capa ambiental: fondo y texto gigante
        const from = PALETTE[base % PALETTE.length] || PALETTE[0];
        const to = PALETTE[(base + 1) % PALETTE.length] || PALETTE[0];
        this.sticky.style.backgroundColor = mix(from, to, Math.min(1, e));
        if (this.ghost) {
          const progress = n > 1 ? pos / (n - 1) : 0;
          const shift = calm ? 0 : -(progress - 0.5) * this.width * 0.12;
          this.ghost.style.transform = `translate3d(${shift.toFixed(1)}px, 0, 0)`;
        }

        this.setActive(Math.round(pos));
      }

      setActive(index) {
        if (index === this.active) return;
        this.active = index;
        const toggle = (el, i) => {
          const on = i === index;
          el.classList.toggle('is-active', on);
          el.inert = !on;
        };
        this.infos.forEach(toggle);
        this.links.forEach(toggle);
        if (this.current) this.current.textContent = String(index + 1).padStart(2, '0');
        this.prevButton?.setAttribute('aria-disabled', String(index <= 0));
        this.nextButton?.setAttribute('aria-disabled', String(index >= this.count - 1));
        if (this.announceNext && this.status) {
          const title = this.infos[index]?.querySelector('.stage__title')?.textContent.trim() || '';
          this.status.textContent = `${index + 1} / ${this.count}: ${title}`;
          this.announceNext = false;
        }
      }

      // Lleva el scroll de la página hasta la meseta del producto elegido
      goTo(index) {
        if (index < 0 || index > this.count - 1 || this.count < 2) return;
        const rect = this.stage.getBoundingClientRect();
        const range = Math.max(1, rect.height - this.sticky.offsetHeight);
        const top = window.scrollY + rect.top + (index / (this.count - 1)) * range;
        this.announceNext = true;
        window.scrollTo({ top: Math.round(top), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }

      destroy() {
        this.abort.abort();
        if (this.raf) cancelAnimationFrame(this.raf);
        this.preload?.disconnect();
        this.stage.classList.remove('is-ready');
      }
    }

    const init = (scope = document) => {
      const found = scope.matches?.('[data-stage-section]') ? [scope] : Array.from(scope.querySelectorAll('[data-stage-section]'));
      found.forEach((section) => {
        if (!stages.has(section)) stages.set(section, new FeaturedStage(section));
      });
    };

    init();
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    document.addEventListener('shopify:section:unload', (e) => {
      stages.forEach((stage, section) => {
        if (e.target === section || e.target.contains(section)) {
          stage.destroy();
          stages.delete(section);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /* Galería de producto: un medio visible, flechas, contador, teclado, deslizamiento y variantes */
  (() => {
    const markReady = (slide) => { if (slide && !slide.classList.contains('is-ready')) slide.classList.add('is-ready'); };
    const pauseMedia = (slide) => {
      slide.querySelectorAll('video').forEach((video) => video.pause());
      slide.querySelectorAll('iframe').forEach((frame) => {
        const msg = frame.src.includes('youtube')
          ? '{"event":"command","func":"pauseVideo","args":""}'
          : frame.src.includes('vimeo') ? '{"method":"pause"}' : null;
        if (msg && frame.contentWindow) frame.contentWindow.postMessage(msg, '*');
      });
    };

    class ProductGallery {
      constructor(root) {
        this.root = root;
        this.slides = Array.from(root.querySelectorAll('[data-pgal-slide]'));
        this.count = this.slides.length;
        this.current = Math.min(Math.max((parseInt(root.dataset.index, 10) || 1) - 1, 0), this.count - 1);
        this.counter = root.querySelector('[data-pgal-current]');
        if (this.count < 2) return;

        root.querySelector('[data-pgal-prev]')?.addEventListener('click', () => this.go(this.current - 1));
        root.querySelector('[data-pgal-next]')?.addEventListener('click', () => this.go(this.current + 1));

        root.addEventListener('keydown', (event) => {
          if (event.target.closest('video, iframe, input, select, textarea')) return;
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.current - 1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); this.go(this.current + 1); }
        });

        // Deslizamiento táctil: solo gestos claramente horizontales; el scroll vertical sigue libre
        const stage = root.querySelector('[data-pgal-stage]');
        let startX = 0;
        let startY = 0;
        let tracking = false;
        stage.addEventListener('touchstart', (event) => {
          if (event.touches.length !== 1 || event.target.closest('video, iframe')) { tracking = false; return; }
          tracking = true;
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        }, { passive: true });
        stage.addEventListener('touchend', (event) => {
          if (!tracking) return;
          tracking = false;
          const touch = event.changedTouches[0];
          const dx = touch.clientX - startX;
          const dy = touch.clientY - startY;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) this.go(this.current + (dx < 0 ? 1 : -1));
        }, { passive: true });
        stage.addEventListener('touchcancel', () => { tracking = false; }, { passive: true });

        // Variantes: si la variante elegida tiene foto propia, se muestra esa foto
        let variantMedia = {};
        try { variantMedia = JSON.parse(root.querySelector('[data-pgal-variants]')?.textContent || '{}'); } catch (error) { variantMedia = {}; }
        const section = root.closest('.shopify-section') || document;
        section.querySelectorAll('select[name="id"], input[type="radio"][name="id"]').forEach((input) => {
          input.addEventListener('change', () => {
            const mediaId = variantMedia[input.value];
            if (!mediaId) return;
            const index = this.slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
            if (index > -1) this.go(index);
          });
        });

        // Las fotos vecinas se preparan cuando la página terminó de cargar
        const warm = () => this.warmNeighbours();
        if (document.readyState === 'complete') setTimeout(warm, 200);
        else window.addEventListener('load', () => setTimeout(warm, 200), { once: true });
      }

      warmNeighbours() {
        markReady(this.slides[(this.current + 1) % this.count]);
        markReady(this.slides[(this.current - 1 + this.count) % this.count]);
      }

      go(target) {
        const next = ((target % this.count) + this.count) % this.count;
        if (next === this.current) return;
        const from = this.slides[this.current];
        const to = this.slides[next];
        markReady(to);
        void to.offsetWidth; // aplica display antes de la transición de opacidad
        pauseMedia(from);
        from.classList.remove('is-active');
        from.setAttribute('aria-hidden', 'true');
        from.inert = true;
        to.classList.add('is-active');
        to.removeAttribute('aria-hidden');
        to.inert = false;
        this.current = next;
        this.root.dataset.index = String(next + 1);
        if (this.counter) this.counter.textContent = String(next + 1);
        this.warmNeighbours();
      }
    }

    const initGalleries = (scope = document) => {
      scope.querySelectorAll('[data-pgal]').forEach((root) => {
        if (root.productGallery) return;
        root.productGallery = new ProductGallery(root);
      });
    };
    initGalleries();
    document.addEventListener('shopify:section:load', (event) => initGalleries(event.target));
  })();

  (() => {
    const init = (root = document) => {
      root.querySelectorAll('[data-product-form]').forEach((form) => {
        if (form.dataset.ajaxReady) return;
        form.dataset.ajaxReady = 'true';
        const button = form.querySelector('[data-add-button]');
        const label = form.querySelector('[data-add-label]');
        const status = form.querySelector('[data-add-status]');
        if (!button || !window.fetch) return;
        const text = {
          added: form.dataset.textAdded,
          viewCart: form.dataset.textViewCart,
          error: form.dataset.textError,
        };

        const setStatus = (html, isError) => {
          status.hidden = false;
          status.classList.toggle('product-form__status--error', !!isError);
          status.innerHTML = html;
        };

        const updateCartCount = (count) => {
          const link = document.getElementById('HeaderCart');
          if (!link) return;
          let badge = link.querySelector('.cart-count');
          if (!badge && count > 0) {
            badge = document.createElement('span');
            badge.className = 'cart-count';
            badge.setAttribute('aria-hidden', 'true');
            badge.innerHTML = '<span class="cart-count__value"></span>';
            link.appendChild(badge);
          }
          if (badge) badge.querySelector('.cart-count__value').textContent = count < 100 ? count : '99+';
        };

        form.addEventListener('submit', async (event) => {
          if (event.submitter && event.submitter !== button) return;
          event.preventDefault();
          if (button.disabled || button.classList.contains('is-loading')) return;

          button.classList.add('is-loading');
          button.setAttribute('aria-busy', 'true');
          status.hidden = true;

          try {
            const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
              method: 'POST',
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: new FormData(form),
            });
            const data = await response.json();
            // Shopify puede agregar menos unidades de las pedidas por stock: el contador se actualiza igual
            const cart = await (await fetch((window.Shopify?.routes?.root || '/') + 'cart.js')).json();
            updateCartCount(cart.item_count);
            if (!response.ok) {
              setStatus(data.description || data.message || text.error, true);
              return;
            }
            label.textContent = text.added;
            setStatus(text.added + ' <a href="' + (window.Shopify?.routes?.root || '/') + 'cart">' + text.viewCart + '</a>');
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            setTimeout(() => { label.textContent = form.dataset.textAdd; }, 2400);
          } catch (error) {
            // Si algo falla en la red, se envía el formulario nativo de Shopify
            form.submit();
          } finally {
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
          }
        });
      });
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
